import { del, patch, post } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError, operationToJSON, valueToDocumentType, } from "../util/amplify-utils";
export default class VelavuAPISiteFloors {
    // This method creates a new floor in an existing site.
    // The boundary response property is computed from the floorplan geojson submitted in the request.
    createNewSiteFloor(siteID, params) {
        return normalizePromiseError(operationToJSON(post({
            apiName: API_NAME_VELAVU,
            path: `/sites/${siteID}/floors`,
            options: {
                body: valueToDocumentType(params),
            },
        })));
    }
    //This method updates a floor in an existing site.
    updateSiteFloor(siteID, floorID, params) {
        return normalizePromiseError(operationToJSON(patch({
            apiName: API_NAME_VELAVU,
            path: `/sites/${siteID}/floors/${floorID}`,
            options: {
                body: valueToDocumentType(params),
            },
        })));
    }
    //This method deletes a site floor by its ID.
    deleteSiteFloor(siteID, floorID) {
        return normalizePromiseError(del({
            apiName: API_NAME_VELAVU,
            path: `/sites/${siteID}/floors/${floorID}`,
        }).response);
    }
}
//# sourceMappingURL=velavu-api-site-floors.js.map